export default __webpack_public_path__ + "static/media/secondOne.2d5338a1.png";